/**
 * Doctor Branson · Regalos y casillas de oferta en el carrito.
 * Usa Shopify.actions.updateCart para que el cajón/página del carrito del tema se actualice solo.
 */
const GID = (id) => `gid://shopify/ProductVariant/${id}`;
const DECLINED_KEY = 'adv_cof_gift_declined';
let busy = false;

function storage(fn, fallback) {
  try {
    return fn(window.sessionStorage);
  } catch (e) {
    return fallback;
  }
}

function actionsReady() {
  return !!(window.Shopify && window.Shopify.actions && window.Shopify.actions.updateCart);
}

/** Devuelve los ids de línea (Storefront API) de las líneas cuyo variante está en `variantIds`. */
async function lineIdsFor(variantIds) {
  const [ajax, sf] = await Promise.all([
    fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()),
    window.Shopify.actions.getCart(),
  ]);
  const sfLines = (sf && sf.cart && sf.cart.lines && (sf.cart.lines.nodes || sf.cart.lines)) || [];
  const wanted = variantIds.map(String);
  const ids = [];
  if (sfLines.length === ajax.items.length) {
    ajax.items.forEach((item, i) => {
      if (wanted.includes(String(item.variant_id)) && sfLines[i]) ids.push(sfLines[i].id);
    });
  }
  return { ids, ajax };
}

async function fallbackChange(adds, removes) {
  for (const id of removes) {
    await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(id), quantity: 0 }),
    });
  }
  if (adds.length) {
    await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: adds.map((id) => ({ id: Number(id), quantity: 1 })) }),
    });
  }
  window.location.reload();
}

async function mutate({ add = [], remove = [] }) {
  if (busy) return;
  busy = true;
  document.querySelectorAll('adv-cart-offers').forEach((el) => el.classList.add('is-busy'));
  try {
    if (!actionsReady()) return await fallbackChange(add, remove);
    const lines = add.map((id) => ({ merchandiseId: GID(id), quantity: 1 }));
    if (remove.length) {
      const { ids } = await lineIdsFor(remove);
      if (ids.length !== remove.length) return await fallbackChange(add, remove);
      ids.forEach((id) => lines.push({ id, quantity: 0 }));
    }
    if (!lines.length) return;
    const result = await window.Shopify.actions.updateCart({ lines });
    if (result && result.userErrors && result.userErrors.length) {
      console.warn('[adv-cart-offers]', result.userErrors);
    }
  } catch (err) {
    console.warn('[adv-cart-offers]', err);
    await fallbackChange(add, remove);
  } finally {
    busy = false;
    document.querySelectorAll('adv-cart-offers').forEach((el) => el.classList.remove('is-busy'));
  }
}

class AdvCartOffers extends HTMLElement {
  static get observedAttributes() {
    return ['data-sig'];
  }

  connectedCallback() {
    if (!this._bound) {
      this._bound = true;
      this.addEventListener('change', (e) => this.onChange(e));
      this.addEventListener('click', (e) => this.onBundle(e));
    }
    this.sync();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== null && oldValue !== newValue) this.sync();
  }

  list(attr) {
    return (this.getAttribute(attr) || '').split(',').filter(Boolean);
  }

  /** Quita regalos si dejan de cumplirse las condiciones y añade el primero si está activado. */
  sync() {
    window.clearTimeout(this._t);
    this._t = window.setTimeout(() => {
      if (busy || !this.isConnected) return;
      const toRemove = this.list('data-remove');
      if (toRemove.length) {
        mutate({ remove: toRemove });
        return;
      }
      const declined = storage((s) => s.getItem(DECLINED_KEY) === '1', false);
      if (this.getAttribute('data-autoadd') === 'true' && !declined) {
        const first = this.querySelector('[data-adv-cof-toggle="gift"]:not(:disabled)');
        if (first) mutate({ add: [first.value] });
      }
    }, 150);
  }

  onBundle(e) {
    const btn = e.target.closest('[data-adv-cof-bundle]');
    if (!btn) return;
    e.preventDefault();
    const ids = (btn.getAttribute('data-ids') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    btn.classList.add('is-loading');
    if (btn.getAttribute('data-adv-cof-bundle') === 'remove') mutate({ remove: ids });
    else mutate({ add: ids });
  }

  onChange(e) {
    const input = e.target.closest('[data-adv-cof-toggle]');
    if (!input) return;
    const type = input.getAttribute('data-adv-cof-toggle');
    const id = input.value;
    input.closest('label')?.classList.toggle('is-on', input.checked);

    if (!input.checked) {
      if (type === 'gift') storage((s) => s.setItem(DECLINED_KEY, '1'));
      mutate({ remove: [id] });
      return;
    }

    if (type === 'gift') {
      storage((s) => s.removeItem(DECLINED_KEY));
      const max = parseInt(this.getAttribute('data-gift-max') || '1', 10);
      const inCart = this.list('data-gifts-in-cart');
      const swap = inCart.length >= max ? inCart.slice(0, inCart.length - max + 1) : [];
      mutate({ add: [id], remove: swap });
      return;
    }
    mutate({ add: [id] });
  }
}

if (!customElements.get('adv-cart-offers')) customElements.define('adv-cart-offers', AdvCartOffers);
